/**
 * @generated SignedSource<<93b8193935bb02fe0e30b56a22b10821>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type sectionSearchResultListSectionSearchConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly content: {
        readonly entityId: string;
        readonly fullSectionPath: ReadonlyArray<{
          readonly name: string;
          readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIfNewsSectionInFirstIndexSection">;
        } | null | undefined> | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"sectionSearchResultListItemSection">;
      } | null | undefined;
      readonly score: number | null | undefined;
    };
  }>;
  readonly " $fragmentType": "sectionSearchResultListSectionSearchConnection";
};
export type sectionSearchResultListSectionSearchConnection$key = {
  readonly " $data"?: sectionSearchResultListSectionSearchConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"sectionSearchResultListSectionSearchConnection">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "sectionSearchResultListSectionSearchConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSearchEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SectionSearchResultItem",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "score",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Section",
              "kind": "LinkedField",
              "name": "content",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "entityId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Section",
                  "kind": "LinkedField",
                  "name": "fullSectionPath",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "helpersCheckIfNewsSectionInFirstIndexSection",
                      "selections": [
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "kind": "InlineFragment",
                              "selections": (v1/*: any*/),
                              "type": "Section",
                              "abstractKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v1/*: any*/),
                              "type": "VideoSection",
                              "abstractKey": null
                            }
                          ],
                          "type": "SectionUnion",
                          "abstractKey": "__isSectionUnion"
                        }
                      ],
                      "args": null,
                      "argumentDefinitions": []
                    },
                    (v0/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "sectionSearchResultListItemSection"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SectionSearchConnection",
  "abstractKey": null
};
})();

(node as any).hash = "8c23dd18a5533bae8c12a6b03f42c0a2";

export default node;
